import { useTheme } from '@mui/material';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Typography } from '../../../components/Typography/Typography';

import { ReactComponent as ArchiveIcon } from '../../../assets/icons/archive.svg';
import { ReactComponent as UnarchiveIcon } from '../../../assets/icons/unarchive.svg';

type Props = {
  anchorEl: null | HTMLElement;
  isArchived: boolean;
  handleClose: () => void;
  toggleArchiveDeal: () => void;
  toggleUnarchiveDeal: () => void;
};

export default function ActionsMenu({
  anchorEl,
  isArchived,
  handleClose,
  toggleArchiveDeal,
  toggleUnarchiveDeal,
}: Props) {
  const open = Boolean(anchorEl);
  const { colors } = useTheme();
  return (
    <Menu
      id='demo-positioned-menu'
      aria-labelledby='demo-positioned-button'
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
    >
      {isArchived ? (
        <MenuItem
          sx={{ svg: { g: { path: { fill: colors.icon.default } } } }}
          onClick={() => {
            handleClose();
            toggleUnarchiveDeal();
          }}
        >
          <UnarchiveIcon fontSize='small' />
          <Typography
            variant='body'
            color={colors.text.main}
            style={{ marginLeft: '4px', marginBottom: '-2px' }}
          >
            Unarchive deal
          </Typography>
        </MenuItem>
      ) : (
        <MenuItem
          sx={{ svg: { g: { path: { fill: colors.icon.default } } } }}
          onClick={() => {
            handleClose();
            toggleArchiveDeal();
          }}
        >
          <ArchiveIcon fontSize='small' />
          <Typography
            variant='body'
            color={colors.text.main}
            style={{ marginLeft: '4px', marginBottom: '-2px' }}
          >
            Archive deal
          </Typography>
        </MenuItem>
      )}
    </Menu>
  );
}
